import { mstrService } from '@/projects/platform/services/mstr-service';
import MstrWrapper from '@/core/wrappers/mstr-wrapper';

export default function MstrLFLSalesReport() {
    return (<MstrWrapper getReport={mstrService.getLFLSalesReport} />);
}